import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-566f1cb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-6 mt-6 border-b-2 border-black-header" }
const _hoisted_2 = {
  class: "nav nav-tabs",
  id: "nav-tab"
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<span class=\"xr-test-net mr-2\" data-v-566f1cb8><span class=\"path1\" data-v-566f1cb8></span><span class=\"path2\" data-v-566f1cb8></span><span class=\"path3\" data-v-566f1cb8></span><span class=\"path4\" data-v-566f1cb8></span></span>", 1)
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<span class=\"xr-main-net mr-2\" data-v-566f1cb8><span class=\"path1\" data-v-566f1cb8></span><span class=\"path2\" data-v-566f1cb8></span><span class=\"path3\" data-v-566f1cb8></span><span class=\"path4\" data-v-566f1cb8></span></span>", 1)
const _hoisted_7 = {
  key: 0,
  class: "items-center flex p-6 pt-6"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-3 w-3 mr-3 bg-yellow-500 inline-block",
  viewBox: "0 0 24 24"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-sm" }, "Loading...", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "md:grid 2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-2 p-3 pt-6 pb-0 overflow-hidden"
}
const _hoisted_13 = { class: "mx-3 mb-6" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text03xl" }, " + "),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Add Token")
], -1))
const _hoisted_15 = {
  key: 1,
  class: "md:grid 2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-2 p-3 pt-6 pb-0 overflow-hidden"
}
const _hoisted_16 = { class: "mx-3 mb-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text03xl" }, " + "),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Add Token")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tokensListTokenBoxComponent = _resolveComponent("tokensListTokenBoxComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: _normalizeClass(["text-gray-text active py-2 px-4", _ctx.currentTab=='testnet'?'bg-black-header':'cursor-pointer']),
          id: "nav-details-tab",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentTab = 'testnet'))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", null, _toDisplayString(_ctx.testnetLabel), 1)
          ])
        ], 2),
        (_ctx.userData.mainnetWalletAddress)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(["text-gray-text active py-2 px-4 ml-2", _ctx.currentTab=='mainnet'?'bg-black-header':'cursor-pointer']),
              id: "nav-details-tab",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentTab = 'mainnet'))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", null, _toDisplayString(_ctx.mainnetLabel), 1)
              ])
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
      : _createCommentVNode("", true),
    (!_ctx.showLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_ctx.currentTab == 'testnet')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testnetTokens, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.tokenId,
                    class: "mx-3 mb-6 perspective"
                  }, [
                    _createVNode(_component_tokensListTokenBoxComponent, {
                      item: item,
                      network: "testnet",
                      otherNetworkItem: _ctx.mainnetTokens.find(token => token.symbol == item.symbol)
                    }, null, 8, ["item", "otherNetworkItem"])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_router_link, {
                    class: _normalizeClass(["border-black-ori border-2 border-dashed rounded-sm shadow-xl p-3 flex items-center justify-center text-white h-52", _ctx.testnetTokens.length == 0?'lg:h-56':'lg:h-full']),
                    to: {name: 'viewTokensCreate', params: { network: 'testnet' }}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }, 8, ["class"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainnetTokens, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.tokenId,
                    class: "mx-3 mb-6"
                  }, [
                    _createVNode(_component_tokensListTokenBoxComponent, {
                      item: item,
                      network: "mainnet",
                      otherNetworkItem: _ctx.testnetTokens.find(token => token.symbol == item.symbol)
                    }, null, 8, ["item", "otherNetworkItem"])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_router_link, {
                    class: _normalizeClass(["border-black-ori border-2 border-dashed rounded-sm shadow-xl p-3 flex items-center justify-center text-white h-52", _ctx.mainnetTokens.length == 0?'lg:h-56':'lg:h-full']),
                    to: {name: 'viewTokensCreate', params: { network: 'mainnet' }}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["class"])
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}